import { AbstractLogger } from './AbstractLogger';
export class LogManager extends AbstractLogger {
    constructor() {
        super(...arguments);
        /** All possible channels for logging */
        this.channels = new Map();
        /** Subset of channels that will be used for stacked logging (meaning the log will be passed to all stack loggers - bubble) */
        this.stack = new Map();
    }
    registerChannel(name, logger, addToStack = false) {
        this.channels.set(name, logger);
        if (addToStack) {
            this.stack.set(name, logger);
        }
        // propagate any already-set context to newly registered channels
        if (Object.keys(this.additionalContext).length > 0) {
            logger.setAdditionalContext(this.additionalContext);
        }
    }
    channel(name) {
        return this.channels.get(name);
    }
    setAdditionalContext(context) {
        super.setAdditionalContext(context);
        // propagate to all registered channels so each logger (Sentry, PostHog, etc.)
        // receives the full merged context
        this.channels.forEach(logger => {
            logger.setAdditionalContext(this.additionalContext);
        });
    }
    setChannelLevel(channelName, level) {
        const channel = this.channels.get(channelName);
        if (channel && 'setMinimumLevel' in channel) {
            channel.setMinimumLevel(level);
            return true;
        }
        return false;
    }
    log(level, message, context) {
        this.stack.forEach((logger, name) => {
            try {
                logger.log(level, message, context);
            }
            catch (error) {
                // Never route back through LogManager.log to avoid recursion
                console.error(`[LogManager] Channel "${name}" threw during log():`, error);
            }
        });
    }
    async destroy() {
        await Promise.all(Array.from(this.stack.values()).map(async (logger) => {
            logger.debug('[LogManager] Destroying logger:', { date: new Date().toISOString() });
            await logger.destroy();
        }));
    }
    async flush(timeout) {
        await Promise.all(Array.from(this.stack.values()).map(async (logger) => {
            await logger.flush(timeout);
        }));
    }
}
//# sourceMappingURL=LogManager.js.map